import { useTranslation } from 'react-i18next'

import {
  Box,
  Flex,
  ListItem,
  ModalBody,
  ModalFooter,
  ModalHeader,
  OrderedList,
} from '@chakra-ui/react'

import { Box as DarkBox, tokenPrefix, tokenVar } from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { Button } from '@/components/ui'

import { GridModalHeader } from '../../components/GridModalHeader'

interface InstructionsStepIProps {
  colorScheme?: ColorScheme
  isTailgateExperience: boolean
  onBegin: () => void
  onClose: () => void
}

export const InstructionsStep = ({
  colorScheme,
  isTailgateExperience,
  onBegin,
  onClose,
}: InstructionsStepIProps) => {
  const { t } = useTranslation()
  const instructions = isTailgateExperience
    ? [
        t('tailgate:grid_test_v2.instruction_1'),
        t('tailgate:grid_test_v2.instruction_2'),
        t('tailgate:grid_test_v2.instruction_3'),
        t('tailgate:grid_test_v2.instruction_4'),
        t('tailgate:grid_test_v2.instruction_5'),
      ]
    : [
        t('tailgate:instructions_step.instruction_1'),
        t('tailgate:instructions_step.instruction_2'),
        t('tailgate:instructions_step.instruction_3'),
        t('tailgate:instructions_step.instruction_4'),
        t('tailgate:instructions_step.instruction_5'),
      ]

  if (colorScheme) {
    return (
      <DarkBox
        as='ol'
        color={tokenVar(`colors.${tokenPrefix(colorScheme)}text.secondary`)}
        display='flex'
        flexDirection='column'
        fontSize='14px'
        gap='8px'
        listStyleType='decimal'
        pl='20px'
      >
        {instructions.map((instruction) => (
          <DarkBox as='li' key={instruction}>
            {instruction}
          </DarkBox>
        ))}
      </DarkBox>
    )
  }

  const content = (
    <Box>
      <OrderedList color='gray.700' fontSize='sm' spacing={2}>
        {instructions.map((instruction) => (
          <ListItem key={instruction}>{instruction}</ListItem>
        ))}
      </OrderedList>
    </Box>
  )

  return (
    <>
      <ModalHeader p={0} w='100%'>
        <GridModalHeader subtitle='' title='Grid Testing Zone' />
      </ModalHeader>
      <ModalBody p={0}>{content}</ModalBody>
      <ModalFooter mt={6} p={0}>
        <Flex direction='row' gap={3} justifyContent='flex-end'>
          <Button mr={0} onClick={onClose} variant='secondary'>
            Cancel
          </Button>
          <Button onClick={onBegin}>Enter</Button>
        </Flex>
      </ModalFooter>
    </>
  )
}
